// Resolves a product image URL for the current environment.
// - Full URLs (http://, https://, data:) are returned as-is (e.g. Cloudinary, external).
// - Relative /uploads/... URLs are prefixed with the API host in production builds
//   where the frontend is served separately from the backend.
// - In dev, the /uploads path is proxied by CRA via frontend/package.json's "proxy" field.

const PLACEHOLDER = 'https://via.placeholder.com/400x400?text=No+Image';

export function resolveImageUrl(url) {
  if (!url) return PLACEHOLDER;
  if (typeof url !== 'string') return PLACEHOLDER;

  // Already absolute or data URI
  if (/^(https?:|data:|blob:)/i.test(url)) return url;

  // Relative /uploads path — prefix with API host when one is configured
  if (url.startsWith('/uploads/')) {
    const apiBase = process.env.REACT_APP_API_URL;
    if (apiBase) {
      // Strip trailing /api (or any suffix) — uploads are served at host root, not under /api
      const host = apiBase.replace(/\/api\/?$/, '').replace(/\/$/, '');
      return `${host}${url}`;
    }
    return url; // dev / same-origin deploy
  }

  return url;
}

export function primaryImageUrl(product) {
  if (!product?.images?.length) return PLACEHOLDER;
  const primary = product.images.find((i) => i.isPrimary) || product.images[0];
  return resolveImageUrl(primary?.url);
}

export { PLACEHOLDER };
